import userTransformer from "@mixins/user-transformer";
import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "/account/partner",

        async create(data) {
            EventBus.$emit("SHOW_SPINNER");

            const parsedUser = userTransformer.parseUser(data);

            const response = await Vue.http
                .post(this.url("/"), {
                    ...parsedUser,
                    isCompany: parsedUser.cpfCnpj.length !== 11
                })
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            EventBus.$emit("LOAD_DATA","")
            return response;
        },

        async find(id) {
            const retorno = await Vue.http.get(this.url(`/${id}`));
            return userTransformer.formatUser(retorno);
            
        },

        async update(data) {
            const url = this.url(`/${data.id}`);
            EventBus.$emit("SHOW_SPINNER");

            const parsedUser = userTransformer.parseUser(data);

            const response = await Vue.http
                .put(url, {
                    ...parsedUser,
                    isCompany: parsedUser.cpfCnpj.length !== 11
                })
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async list({page,size,filter,order,desc}) {
            const url = this.url("/list"
            );
            const retorno =  await Vue.http.get(url, {
                params: {
                    page,
                    size,
                    filter,
                    order,
                    desc
                }
            });
            return retorno
        },

        async establishmentList() {
            const url = this.url("/establishment-list");
            const retorno =  await Vue.http.get(url)
            return retorno
        },

    

        async activate(id) {
            const url = this.url(`/${id}/status`);

            return await Vue.http.put(url);
        },


        async clearAccess({ establishmentId, email }) {
            const url = this.url(`/${establishmentId}/acesso/clear`);
            
            return Vue.http.post(url, { email });
        },

        async togglePermission({ partnerId, permissionKey  }) {
            const url = this.url(`/${partnerId}/permission`);

            return Vue.http.patch(url, permissionKey, {
                headers: { "Content-Type": "text/plain" }
            });
        },

        async toggleEstablishmentManageablePermission({
            partnerId,
            permissionKey,
        }) {
            const url = this.url(`/${partnerId}/establishment/permission`);

            return Vue.http.patch(url, permissionKey, {
                headers: { "Content-Type": "text/plain" },
            });
        },

         async getEstablishmentManageablePermission(partnerId) {
            const url = this.url(`/${partnerId}/establishment/permission`);
            return Vue.http.get(url)
            
        },
    },
    base
);
